import server from "./server";

export const getVisitsReportApi = async (props) => {
  const response = await server().get(`/visits?${props || ""}`);
  return response.data;
};
